import React, { useId } from 'react';

interface SupportChatBotLottieIconProps {
  isOpen: boolean;
  size?: number;
}

const SupportChatBotLottieIcon: React.FC<SupportChatBotLottieIconProps> = ({ isOpen, size = 42 }) => {
  const iconClassName = `support-chatbot__toggle-icon-lottie${
    isOpen ? ' support-chatbot__toggle-icon-lottie--open' : ''
  }`;
  const gradientBaseId = useId();
  const bubbleGradientId = `${gradientBaseId}-bubble`;
  const bubbleRingId = `${gradientBaseId}-ring`;
  const bubbleHighlightId = `${gradientBaseId}-highlight`;

  return (
    <svg
      className={iconClassName}
      style={{ width: size, height: size }}
      viewBox="0 0 64 64"
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={bubbleGradientId} x1="12%" y1="8%" x2="88%" y2="92%">
          <stop offset="0%" stopColor="#32e6d4" />
          <stop offset="45%" stopColor="#1dbbb1" />
          <stop offset="100%" stopColor="#027e7b" />
        </linearGradient>
        <linearGradient id={bubbleRingId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 255, 255, 0.65)" />
          <stop offset="100%" stopColor="rgba(255, 255, 255, 0.18)" />
        </linearGradient>
        <radialGradient id={bubbleHighlightId} cx="32" cy="18" r="18" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="rgba(255, 255, 255, 0.75)" />
          <stop offset="100%" stopColor="rgba(255, 255, 255, 0)" />
        </radialGradient>
      </defs>

      <g className="support-chatbot__bubble">
        <path
          className="support-chatbot__bubble-fill"
          d="M32 8c-12.15 0-22 9.28-22 20.732 0 5.184 2.134 9.99 5.772 13.528L15 55.5l10.355-4.804C27.998 51.496 30.01 52 32 52c12.15 0 22-9.28 22-20.732S44.15 8 32 8z"
          fill={`url(#${bubbleGradientId})`}
        />
        <path
          className="support-chatbot__bubble-stroke"
          d="M32 10.5c-10.684 0-19.5 8.13-19.5 18.232 0 4.623 1.992 8.91 5.269 12.154l.884.871-.913 8.804 7.906-3.665.658-.305.707.226c1.751.563 3.572.854 5.489.854 10.684 0 19.5-8.13 19.5-18.232C51 18.63 42.684 10.5 32 10.5z"
          fill="none"
          stroke={`url(#${bubbleRingId})`}
          strokeWidth="1.6"
        />
        <path
          className="support-chatbot__bubble-highlight"
          d="M21.5 16.5c1.835-2.092 5.538-4.02 10.63-4.02 7.516 0 13.632 4.251 15.984 10.137-4.488-3.033-10.085-4.793-16.3-4.793-3.668 0-7.054.567-10.314 1.66z"
          fill={`url(#${bubbleHighlightId})`}
        />
      </g>

      <g className="support-chatbot__antenna">
        <path className="support-chatbot__antenna-stem" d="M32 6.2v-4.2" stroke="rgba(255,255,255,0.65)" strokeWidth="2.2" strokeLinecap="round" />
        <circle className="support-chatbot__antenna-orb" cx="32" cy="2" r="2.6" fill="#9ff5ec" />
      </g>

      <g className="support-chatbot__face">
        <circle className="support-chatbot__eye support-chatbot__eye--left" cx="24.5" cy="31.5" r="2.8" fill="#043f3d" />
        <circle className="support-chatbot__eye support-chatbot__eye--right" cx="39.5" cy="31.5" r="2.8" fill="#043f3d" />
        <rect
          className="support-chatbot__mouth"
          x="26.4"
          y="36"
          width="11.2"
          height="5.4"
          rx="2.7"
          fill="#f4fdfc"
        />
        <path
          className="support-chatbot__visor"
          d="M22 26.5c0-4.142 4.03-7.5 9-7.5s9 3.358 9 7.5"
          fill="none"
          stroke="rgba(255,255,255,0.6)"
          strokeWidth="2.3"
          strokeLinecap="round"
        />
      </g>

      <g className="support-chatbot__chat-waves">
        <path className="support-chatbot__wave support-chatbot__wave--one" d="M42.5 25.2c3.6 1.2 6.4 4.32 6.4 8.06" stroke="rgba(255,255,255,0.62)" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path className="support-chatbot__wave support-chatbot__wave--two" d="M19.1 25.2c-3.6 1.2-6.4 4.32-6.4 8.06" stroke="rgba(255,255,255,0.45)" strokeWidth="2" strokeLinecap="round" fill="none" />
      </g>

      <g className="support-chatbot__dots" fill="#f4fdfc">
        <circle className="support-chatbot__spark support-chatbot__spark--one" cx="18" cy="18" r="1.7" />
        <circle className="support-chatbot__spark support-chatbot__spark--two" cx="46.5" cy="18.4" r="1.3" />
      </g>
    </svg>
  );
};

export default SupportChatBotLottieIcon;